var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcGeolocation = function SvgIcGeolocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.988 7.275c0 4.103-5.014 7.62-5.014 7.62s-5.015-3.517-5.015-7.62c0-1.399.528-2.74 1.469-3.73A4.892 4.892 0 0 1 9.974 2c1.33 0 2.605.556 3.545 1.545a5.417 5.417 0 0 1 1.469 3.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.974 9.033c.923 0 1.671-.787 1.671-1.758s-.748-1.758-1.671-1.758c-.924 0-1.672.787-1.672 1.758s.748 1.758 1.672 1.758ZM4.592 12.124h-.713c-.728 0-1.39.419-1.703 1.076l-.895 1.884a1.885 1.885 0 0 0 1.702 2.695h14.028a1.885 1.885 0 0 0 1.701-2.698l-.9-1.884a1.885 1.885 0 0 0-1.7-1.073h-.76"
  })));
};
export default SvgIcGeolocation;